import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { LatestAdditionsBlock } from '../../_blocks/LatestAdditions';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type LatestAdditionsWidget = ContextWidget<LatestAdditionsBlock, WidgetType.latestadditions>;

export function LatestAdditionsWidget(props: LatestAdditionsWidget) {
  const { t } = useSonTranslation('LatestAdditions');
  return <DefaultContextWidget icon={Icons.LATEST_ADDITIONS} title={t('widgetTitle')} {...props} />;
}
